/*
 * VueX - State Management
 */

import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import router from "../router";
//import menu from '../data/menu'
import VueMoment from "vue-moment";

// Register Vuex
Vue.use(Vuex);
Vue.use(VueMoment);

// Helpers
const helpers = {
  getWindowWidth() {
    return (
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth
    );
  },
  getCurrentYear() {
    return new Date().getFullYear();
  },
};

// Vuex Store
export default new Vuex.Store({
  state: {
    // App vital details
    app: {
      name: "Aptitude Buster",
      //version: process.env.PACKAGE_VERSION,
      copyright: helpers.getCurrentYear(),
    },

    // Default layout options
    layout: {
      header: true,
      sidebar: true,
      sideOverlay: true,
      footer: true,
    },

    // Default template settings
    // Various of them are also set in each layout variation under layouts/variations/ folder
    settings: {
      colorTheme: "", // 'amethyst', 'city', 'flat', 'modern', 'smooth'
      sidebarLeft: true,
      sidebarMini: false,
      sidebarDark: true,
      sidebarVisibleDesktop: true,
      sidebarVisibleMobile: false,
      sideOverlayVisible: false,
      sideOverlayHoverable: false,
      pageOverlay: true,
      headerFixed: true,
      headerDark: false,
      headerSearch: false,
      headerLoader: false,
      pageLoader: false,
      rtlSupport: false,
      sideTransitions: true,
      mainContent: "", // 'boxed', ''narrow'
    },

    //Login States
    status: "",
    token: localStorage.getItem("token") || "",
    user: localStorage.getItem("userDetail") || "",
    userName: localStorage.getItem("userName") || "",
    loginErrors: "",

    //College Login States
    // collegeStatus: '',
    collegeToken: localStorage.getItem("collegeToken") || "",
    collegeLoginErrors: "",
    collegeId: localStorage.getItem("collegeId") || "",
    collegeUrl: localStorage.getItem("collegeUrl") || "",
    collegeUserName: localStorage.getItem("collegeUserName") || "",
    collegeCollegeId: localStorage.getItem("collegeCollegeId") || "",
    collegeStatus: localStorage.getItem("collegeStatus") || "",
    collegeType: localStorage.getItem("collegeType") || "",
    // collegeSidebar:
    //   [
    //     {
    //       name: 'Students List',
    //       to: `/backend/tables/college/${localStorage.getItem('collegeUrl')}/users`,
    //       icon: 'si si-speedometer'
    //     },
    //     {
    //       name: 'Subscriptions',
    //       to: `/backend/tables/college/${localStorage.getItem('collegeUrl')}/subscriptions`,
    //       icon: 'si si-speedometer'
    //     },
    //     {
    //       name: 'Departments',
    //       to: `/backend/tables/college/${localStorage.getItem('collegeUrl')}/departments`,
    //       icon: 'si si-speedometer'
    //     },
    //     {
    //       name: 'Hods',
    //       to: `/backend/tables/college/${localStorage.getItem('collegeUrl')}/hods`,
    //       icon: 'si si-speedometer'
    //     },
    //     {
    //       name: 'Classes',
    //       to: `/backend/tables/college/${localStorage.getItem('collegeUrl')}/classes`,
    //       icon: 'si si-speedometer'
    //     },
    //     {
    //       name: 'Students',
    //       to: `/backend/tables/college/${localStorage.getItem('collegeUrl')}/students`,
    //       icon: 'si si-speedometer'
    //     },
    //     {
    //       name: 'Test Reports',
    //       to: `/backend/tables/college/${localStorage.getItem('collegeUrl')}/test_reports`,
    //       icon: 'si si-speedometer'
    //     }
    //   ],

    // baseUrl: "http://192.168.1.11/aptitude_buster/public/crm-api",
    baseUrl:
      // "https://test.aptitudebuster.com/aptitude_buster/public/index.php/crm-api", //live
      // "https://dev-script.aptitudebuster.com/public/crm-api", // Dev
      // "http://192.168.0.38/aptitude_buster/public/crm-api", //LOCAL
      // "http://192.168.0.38:8000/crm-api", //LOCAL
      "https://uat-script.aptitudebuster.com/public/crm-api", // UAT
      // "https://test-testing.aptitudebuster.com/public/index.php/crm-api", //testUrl
      //testUrl = "http://crmbackend.aptitudebuster.com/aptitude_buster/public/index.php/crm-api"
      // baseUrl: "https://laraveltesting.aptitudebuster.com/aptitude_buster/public/index.php/crm-api",
    //Category States
    categories: [],
    addCategoryError: "",
  },
  getters: {
    //Login getters
    isLoggedIn: (state) => !!state.token,
    authStatus: (state) => state.status,
    loginErrors: (state) => state.loginErrors,
    token: (state) => state.token,
    baseUrl: (state) => state.baseUrl,
    userDetails: (state) => state.user,
    userName: (state) => state.userName,

    //College login getters
    collegeIsLoggedIn: (state) => !!state.collegeToken,
    collegeAuthStatus: (state) => state.collegeStatus,
    collegeLoginErrors: (state) => state.collegeLoginErrors,
    collegeToken: (state) => state.collegeToken,
    collegeId: (state) => state.collegeId,
    collegeUrl: (state) => state.collegeUrl,
    collegeUserName: (state) => state.collegeUserName,
    collegeCollegeId: (state) => state.collegeCollegeId,
    collegeStatus: (state) => state.collegeStatus,
    collegeType: (state) => state.collegeType,

    // Get App name
    appName: (state) => {
      return state.app.name;
    },
    // Get App version
    appVersion: (state) => {
      return state.app.version;
    },
    // Get App copyright year
    appCopyright: (state) => {
      return state.app.copyright;
    },
    // Get app color theme
    appColorTheme: (state) => {
      return state.settings.colorTheme;
    },
  },
  actions: {
    //Login College actions
    async collegeLogin({ commit }, user) {
      const formdata = new FormData();
      formdata.append("url", user.url);
      formdata.append("username", user.username);
      formdata.append("password", user.password);
      formdata.append("college_id", user.college_id);
      console.log("login");
      await axios
        .post(`${this.state.baseUrl}/college_login`, formdata)
        .then((resp) => {
          console.log("login-response");
          console.log(resp);
          const token = resp.data.token;
          localStorage.setItem("collegeToken", token);
          const collegeId = resp.data.college_admin.id;
          const collegeUrl = user.url;
          const collegeUserName = resp.data.college_admin.username;
          const collegeCollegeId = resp.data.college_admin.college_id;
          const collegeStatus = resp.data.college_admin.status;
          const collegeType = resp.data.college_admin.type;
          localStorage.setItem("collegeId", collegeId);
          localStorage.setItem("collegeUrl", collegeUrl);
          localStorage.setItem("collegeUserName", collegeUserName);
          localStorage.setItem("collegeCollegeId", collegeCollegeId);
          localStorage.setItem("collegeStatus", collegeStatus);
          localStorage.setItem("collegeType", collegeType);
          axios.defaults.headers.common["Authorization"] = token;
          commit("college_auth_success", {
            token,
            collegeId,
            collegeUrl,
            collegeUserName,
            collegeCollegeId,
            collegeStatus,
            collegeType,
          });
          commit("college_reset_login_errors");
          router.push(`/backend/college/${user.url}/dashboard`);
        })
        .catch((err) => {
          console.log("err", err.response.data);
          if (err.response.data.status == "error") {
            commit("set_college_login_errors", err);
          } else {
            commit("auth_college_error");
            localStorage.removeItem("collegeToken");
            localStorage.removeItem("collegeId");
            localStorage.removeItem("collegeUrl");
            localStorage.removeItem("collegeUserName");
            localStorage.removeItem("collegeCollegeId");
            localStorage.removeItem("collegeStatus");
            localStorage.removeItem("collegeType");
          }
        });
    },

    //Login actions
    async login({ commit }, user) {
      await axios
        .post(`${this.state.baseUrl}/crm-login`, user)
        .then((resp) => {
          console.log("loginResponse", resp);
          const token = resp.data.authentication.token;
          const userDetail = resp.data.authentication.permissions;
          const userName = resp.data.authentication.name;
          axios.defaults.headers.common["Authorization"] = token;
          console.log("logUser", userDetail);
          commit("auth_success", { token, userDetail, userName });
          commit("reset_login_errors");
        })
        .catch((err) => {
          console.log("err", err.response);
          if (err.response.data.status == "error") {
            commit("set_login_errors", err);
          } else {
            commit("auth_error");
            localStorage.removeItem("token");
          }
        });
    },

    //Logout action
    logout({ commit }) {
      commit("logout");
      localStorage.removeItem("token");
      delete axios.defaults.headers.common["Authorization"];
    },

    //Logout college action
    collegeLogout({ commit }) {
      commit("college_Logout");
      localStorage.removeItem("collegeToken");
      localStorage.removeItem("collegeId");
      localStorage.removeItem("collegeUrl");
      localStorage.removeItem("collegeCollegeId");
      localStorage.removeItem("collegeStatus");
      localStorage.removeItem("collegeType");
      delete axios.defaults.headers.common["Authorization"];
    },
  },
  mutations: {
    //college login mutation
    college_reset_login_errors: (state) => {
      state.collegeLoginErrors = "";
    },
    set_college_login_errors: (state, err) => {
      state.collegeLoginErrors = err.response.data.message;
    },
    college_auth_success(state, payload) {
      state.collegeStatus = "success";
      state.collegeToken = payload.token;
      state.collegeId = payload.collegeId;
      state.collegeUrl = payload.collegeUrl;
      state.collegeUserName = payload.collegeUserName;
      state.collegeCollegeId = payload.collegeCollegeId;
      state.collegeStatus = payload.collegeStatus;
      state.collegeType = payload.collegeType;
      // state.collegeSidebar[0]['to'] = `/backend/tables/college/${payload.collegeUrl}/users`
      // state.collegeSidebar[1]['to'] = `/backend/tables/college/${payload.collegeUrl}/subscriptions`
    },
    auth_college_error(state) {
      state.collegeStatus = "error";
    },
    college_Logout(state) {
      state.collegeStatus = "";
      state.collegeToken = "";
      state.collegeId = "";
      state.collegeUrl = "";
      state.collegeUserName = "";
      state.collegeCollegeId = "";
      state.collegeStatus = "";
      state.collegeType = "";
    },

    //Login mutation
    reset_login_errors: (state) => {
      state.loginErrors = "";
    },
    set_login_errors: (state, err) => {
      state.loginErrors = err.response.data.message;
    },
    auth_success(state, payload) {
      state.status = "success";
      localStorage.setItem("token", payload.token);
      localStorage.setItem("userDetail", payload.userDetail);
      localStorage.setItem("userName", payload.userName);
      state.token = localStorage.getItem("token");
      state.user = localStorage.getItem("userDetail");
      state.userName = localStorage.getItem("userName");
      router.push("/backend/dashboard");
    },
    auth_error(state) {
      state.status = "error";
    },
    logout(state) {
      localStorage.clear();
      state.status = "";
      state.token = "";
      state.user = {};
      state.userName = "";
    },

    // Sets the layout, useful for setting different layouts (under layouts/variations/)
    setLayout(state, payload) {
      state.layout.header = payload.header;
      state.layout.sidebar = payload.sidebar;
      state.layout.sideOverlay = payload.sideOverlay;
      state.layout.footer = payload.footer;
    },
    // Sets sidebar visibility (open, close, toggle)
    sidebar(state, payload) {
      if (helpers.getWindowWidth() > 991) {
        if (payload.mode === "open") {
          state.settings.sidebarVisibleDesktop = true;
        } else if (payload.mode === "close") {
          state.settings.sidebarVisibleDesktop = false;
        } else if (payload.mode === "toggle") {
          state.settings.sidebarVisibleDesktop = !state.settings
            .sidebarVisibleDesktop;
        }
      } else {
        if (payload.mode === "open") {
          state.settings.sidebarVisibleMobile = true;
        } else if (payload.mode === "close") {
          state.settings.sidebarVisibleMobile = false;
        } else if (payload.mode === "toggle") {
          state.settings.sidebarVisibleMobile = !state.settings
            .sidebarVisibleMobile;
        }
      }
    },
    // Sets sidebar mini mode (on, off, toggle)
    sidebarMini(state, payload) {
      if (helpers.getWindowWidth() > 991) {
        if (payload.mode === "on") {
          state.settings.sidebarMini = true;
        } else if (payload.mode === "off") {
          state.settings.sidebarMini = false;
        } else if (payload.mode === "toggle") {
          state.settings.sidebarMini = !state.settings.sidebarMini;
        }
      }
    },
    // Sets sidebar position (left, right, toggle)
    sidebarPosition(state, payload) {
      if (payload.mode === "left") {
        state.settings.sidebarLeft = true;
      } else if (payload.mode === "right") {
        state.settings.sidebarLeft = false;
      } else if (payload.mode === "toggle") {
        state.settings.sidebarLeft = !state.settings.sidebarLeft;
      }
    },
    // Sets sidebar style (dark, light, toggle)
    sidebarStyle(state, payload) {
      if (payload.mode === "dark") {
        state.settings.sidebarDark = true;
      } else if (payload.mode === "light") {
        state.settings.sidebarDark = false;
      } else if (payload.mode === "toggle") {
        state.settings.sidebarDark = !state.settings.sidebarDark;
      }
    },
    // Sets side overlay visibility (open, close, toggle)
    sideOverlay(state, payload) {
      if (payload.mode === "open") {
        state.settings.sideOverlayVisible = true;
      } else if (payload.mode === "close") {
        state.settings.sideOverlayVisible = false;
      } else if (payload.mode === "toggle") {
        state.settings.sideOverlayVisible = !state.settings.sideOverlayVisible;
      }
    },
    // Sets side overlay hover mode (on, off, toggle)
    sideOverlayHover(state, payload) {
      if (payload.mode === "on") {
        state.settings.sideOverlayHoverable = true;
      } else if (payload.mode === "off") {
        state.settings.sideOverlayHoverable = false;
      } else if (payload.mode === "toggle") {
        state.settings.sideOverlayHoverable = !state.settings
          .sideOverlayHoverable;
      }
    },
    // Sets page overlay visibility (on, off, toggle)
    pageOverlay(state, payload) {
      if (payload.mode === "on") {
        state.settings.pageOverlay = true;
      } else if (payload.mode === "off") {
        state.settings.pageOverlay = false;
      } else if (payload.mode === "toggle") {
        state.settings.pageOverlay = !state.settings.pageOverlay;
      }
    },
    // Sets header mode (fixed, static, toggle)
    header(state, payload) {
      if (payload.mode === "fixed") {
        state.settings.headerFixed = true;
      } else if (payload.mode === "static") {
        state.settings.headerFixed = false;
      } else if (payload.mode === "toggle") {
        state.settings.headerFixed = !state.settings.headerFixed;
      }
    },
    // Sets header style (dark, light, toggle)
    headerStyle(state, payload) {
      if (payload.mode === "dark") {
        state.settings.headerDark = true;
      } else if (payload.mode === "light") {
        state.settings.headerDark = false;
      } else if (payload.mode === "toggle") {
        state.settings.headerDark = !state.settings.headerDark;
      }
    },
    // Sets header search visibility (on, off, toggle)
    headerSearch(state, payload) {
      if (payload.mode === "on") {
        state.settings.headerSearch = true;
      } else if (payload.mode === "off") {
        state.settings.headerSearch = false;
      } else if (payload.mode === "toggle") {
        state.settings.headerSearch = !state.settings.headerSearch;
      }
    },
    // Sets header loader visibility (on, off, toggle)
    headerLoader(state, payload) {
      if (payload.mode === "on") {
        state.settings.headerLoader = true;
      } else if (payload.mode === "off") {
        state.settings.headerLoader = false;
      } else if (payload.mode === "toggle") {
        state.settings.headerLoader = !state.settings.headerLoader;
      }
    },
    // Sets page loader visibility (on, off, toggle)
    pageLoader(state, payload) {
      if (payload.mode === "on") {
        state.settings.pageLoader = true;
      } else if (payload.mode === "off") {
        state.settings.pageLoader = false;
      } else if (payload.mode === "toggle") {
        state.settings.pageLoader = !state.settings.pageLoader;
      }
    },
    // Sets main content mode (full, boxed, narrow)
    mainContent(state, payload) {
      if (payload.mode === "full") {
        state.settings.mainContent = "";
      } else if (payload.mode === "boxed") {
        state.settings.mainContent = "boxed";
      } else if (payload.mode === "narrow") {
        state.settings.mainContent = "narrow";
      }
    },
    // Sets active color theme
    setColorTheme(state, payload) {
      // Matches all classes which start with "theme-"
      let regx = new RegExp("\\btheme-[^ ]*[ ]?\\b", "g");

      // Set new theme
      state.settings.colorTheme = payload.theme || "";

      // Remove all classes which start with "theme-" from body element
      document.body.className = document.body.className.replace(regx, "");

      // If theme is set, add the theme class to body element
      if (payload.theme) {
        document.body.classList.add("theme-" + payload.theme);
      }
    },
  },
});
